import { render, staticRenderFns } from "./AuthSimple.vue?vue&type=template&id=99cb4f70&scoped=true"
import script from "./AuthSimple.vue?vue&type=script&lang=ts"
export * from "./AuthSimple.vue?vue&type=script&lang=ts"
import style0 from "./AuthSimple.vue?vue&type=style&index=0&id=99cb4f70&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb4f70",
  null
  
)

export default component.exports